import PageFieldsLayer from './PageFieldsLayer.component';

export default PageFieldsLayer;
